import { Row, Col } from "antd";
import { Typography, FormControlLabel, Switch, TextField, Button, FormControl, FormLabel, FormGroup, Checkbox } from "@mui/material";
import { AutoCompleteComponent } from "../../../../../Shared/components/AutoCompleteComponent";
import { templateType } from '../../../../../../config/constant';
import { Link } from "react-router-dom";


export const HeaderView = (props) => {
    const { classes, clsx, form, error, changeHandler, customerDetails, changeCustomer, view,
        customerApi, handleScheduleEdit,
        customObject, idNamingConversion, type, loader } = props;
    return (
        <>
            <Row gutter={50}>
                <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                    {
                        view ? <>
                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin30t, classes.fonSize13)}>Customer Name </Typography>
                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.customer?.name || '---'}</Typography>
                        </> :
                            <AutoCompleteComponent
                                name={["Customer Name ", <span key={"Customer Name"} className={classes.colorRedRequired}> *</span>]}
                                heads={[{ 'key': 'name', 'name': 'Customer Name' },
                                { 'key': 'mobile', 'name': 'Phone Number' },
                                { 'key': 'serialNo', 'name': 'Customer ID' }]}
                                details={customerDetails}
                                id={idNamingConversion('customerName', 'customerProductScheduling', 'DropDown')}
                                parentValue={customObject(customerDetails, form?.customerId)}
                                onChange={(data) => changeCustomer(data)}
                                searchType={(s) => customerApi(s)}
                                parentError={error?.customerId || false}
                                position={"bottom"}
                                disabled={type !== 'create' ? true : false}
                                customClasses={classes.margin20t}
                            />
                    }
                </Col>
                <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                    {
                        view ? <>
                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin30t, classes.fonSize13)}>Customer ID</Typography>
                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.customer?.serialNo || '----'}</Typography>
                        </> : <>
                            <Typography variant={'h6'} className={clsx(classes.textFieldLableColorCustom, classes.margin20t, 'MuiInputLabel-shrink', classes.fonSize13)}>Customer ID</Typography>
                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.customer?.serialNo || '----'}</Typography>
                        </>
                    }
                </Col>
                <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                    {
                        view ? <>
                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Status</Typography>
                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.scheduleStatus ? 'Active' : 'Inactive'}</Typography>
                        </> :
                            <FormControlLabel
                                classes={{
                                    label: clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13), // Pass your override css here
                                }}
                                control={<Switch size='small'
                                    className={clsx(classes.customSwitch)}
                                    onChange={(e) => changeHandler(!form?.scheduleStatus, 'scheduleStatus')}
                                />}
                                id={idNamingConversion('status', 'customerProductScheduling', 'Radio')}
                                label="Status"
                                labelPlacement="top"
                                checked={form?.scheduleStatus || false}
                                className={clsx(classes.marginLeft0, classes.flexStart, classes.margin20t)}
                            />
                    }
                </Col>
                <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                    {
                        view ? <>
                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Send Notifications</Typography>
                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.sendNotification ? 'Yes' : 'No'}</Typography>
                        </> :
                            <FormControlLabel
                                classes={{
                                    label: clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13), // Pass your override css here
                                }}
                                control={<Switch size='small'
                                    className={clsx(classes.customSwitch)}
                                    onChange={(e) => changeHandler(!form?.sendNotification, 'sendNotification')}
                                />}
                                id={idNamingConversion('Send Notifications', 'customerProductScheduling', 'Radio')}
                                label="Send Notifications"
                                labelPlacement="top"
                                checked={form?.sendNotification || false}
                                className={clsx(classes.marginLeft0, classes.flexStart, classes.margin20t)}
                            />
                    }
                </Col>
                <Col xxl={4} xl={4} lg={4} md={4} sm={12} xs={24} className={classes.textAlignRight}>
                    {
                        view ? <Link onClick={() => handleScheduleEdit('edit')} to={'#'}
                            className={clsx(classes.AddMoreBtn, classes.bold, classes.marginRight0)}>Edit</Link> : <Button
                                tabIndex={-1}
                                key="Save"
                                type="submit"
                                color="primary"
                                variant="contained"
                                className={clsx(classes.modalBtn, { [classes.loading]: loader })}
                            >{type === 'create' ? 'Save' : 'Update'}</Button>
                    }
                </Col>
                <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                    {
                        view ? <>
                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin30t, classes.fonSize13)}>Phone Number </Typography>
                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.phone || '---'}</Typography>
                        </> :
                            <TextField autoComplete='one-time-code'
                                label={["Phone Number ", <span key={"Phone Number"} className={classes.colorRedRequired}> *</span>]}
                                fullWidth
                                // type="number"
                                name={"phone"}
                                id={idNamingConversion('Phone Number', 'customerProductScheduling', 'TextField')}
                                className={clsx(classes.margin20t)}
                                error={error?.phone && true}
                                helperText={error?.phone}
                                variant={'standard'}
                                value={form?.phone || ''}
                                InputProps={{
                                    classes: {
                                        input: classes.textFieldColor
                                    }
                                }}
                                InputLabelProps={{
                                    className: classes.textFieldLableColorCustom
                                }}
                                onChange={(e) => changeHandler(e)}
                            />
                    }
                </Col>
                <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                    {
                        view ? <>
                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin30t, classes.fonSize13)}>Email</Typography>
                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.email || '---'}</Typography>
                        </> :
                            <TextField autoComplete='one-time-code'
                                label={["Email ID"]}
                                fullWidth
                                name="email"
                                error={error?.email && true}
                                helperText={error?.email}
                                id={idNamingConversion('Email', 'customerProductScheduling', 'TextField')}
                                className={clsx(classes.margin20t)}
                                variant={'standard'}
                                value={form?.email || ''}
                                InputProps={{
                                    classes: {
                                        input: classes.textFieldColor
                                    }
                                }}
                                InputLabelProps={{
                                    className: classes.textFieldLableColorCustom
                                }}
                                onChange={(e) => changeHandler(e)}
                            />
                    }
                </Col>
                <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                    {
                        view ? <>
                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin30t, classes.fonSize13)}>Invoice Format</Typography>
                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.billFormat || '---'}</Typography>
                        </> :
                            <AutoCompleteComponent
                                name={["Invoice Format"]}
                                id={idNamingConversion('billFormat', 'customerProductScheduling', 'DropDown')}
                                heads={[{ 'key': 'label', 'name': 'Name' }]}
                                details={templateType}
                                parentValue={customObject(templateType, form?.billFormat)}
                                onChange={(data) => changeHandler(data.id, 'billFormat')}
                                position={'bottom'}
                                parentError={error?.billFormat || false}
                                customClasses={clsx(classes.customAutocomplete, classes.customerInvoice, classes.margin20t)}
                            />
                    }
                </Col>
                <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                    <FormControl className={clsx(classes.customGroupCheckBok, classes.margin20t, { [classes.disabled]: !form?.sendNotification })}>
                        <FormLabel className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Notifications</FormLabel>
                        <FormGroup aria-label="position" row >
                            <FormControlLabel
                                value="email"
                                control={<Checkbox size={'small'}
                                    onChange={(data) => changeHandler(!form.notifyEmail, 'notifyEmail')}
                                />}
                                checked={form?.notifyEmail || false}
                                label="Email"
                                labelPlacement="end"
                            />
                            <FormControlLabel
                                value="phone"
                                control={<Checkbox size={'small'}
                                    onChange={(data) => changeHandler(!form.notifyPhone, 'notifyPhone')}
                                />}
                                checked={form?.notifyPhone || false}
                                label="Phone"
                                labelPlacement="end"
                            />
                        </FormGroup>
                    </FormControl>
                </Col>
            </Row>
        </>
    )
}